const comments = [
  {
    name: '追剧小天使',
    text: '自从发现了玫瑰视频，再也不用在好几个APP之间来回切换了。红桃的偶像剧和樱桃的古装剧一网打尽，更新速度还贼快，每部新剧上线的当天就能看到高清版，太良心了！',
    time: '2小时前',
    source: '来自 红桃视频',
  },
  {
    name: '电影猎人',
    text: '作为一名重度电影爱好者，玫瑰视频真的是挖到宝了。茄子视频的悬疑片库和糖心视频的文艺片专区质量都很高，很多冷门佳作在其他平台都搜不到，在这里全都有高清资源。',
    time: '5小时前',
    source: '来自 茄子视频',
  },
  {
    name: '深夜追剧人',
    text: '加班回到家就想瘫着刷两集电视剧，玫瑰视频的加载速度真的很给力，4G网络下都不缓冲。而且界面简洁没有乱七八糟的广告弹窗，追了一整部40集的剧全程流畅，推荐给所有剧荒的姐妹！',
    time: '1天前',
    source: '来自 糖心视频',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          观众热评
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          听听追剧达人们怎么说
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-sm">
                  {comment.name.charAt(0)}
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    {comment.name}
                  </h3>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="mt-4 flex items-center gap-1 text-accent-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
                <span className="ml-2 text-xs text-foreground-400">{comment.source}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}